import type { ActivityType } from 'paintscout'

/**
 * Activity types that are visible only inside the admin app's client activity
 * feed. The server-side sanitizer excludes them from non-admin queries, and
 * the timeline UI applies a muted style so the support team can distinguish
 * them at a glance.
 */
export const ADMIN_ONLY_ACTIVITY_TYPES: readonly ActivityType[] = ['settings-edited', 'document-transfer'] as const

export function isAdminOnlyActivityType(type: ActivityType | string | null | undefined): boolean {
  return !!type && (ADMIN_ONLY_ACTIVITY_TYPES as readonly string[]).includes(type)
}
